module.exports = __webpack_public_path__ + "img/171.food_variety.7e9ac088.svg";